import { Truck, BadgePercent, ShieldCheck, Phone } from "lucide-react";
import { Link } from "react-router-dom";

export const TopBar = () => (
  <div data-testid="top-bar" className="hidden md:block bg-vr-navy text-white/85 text-xs">
    <div className="max-w-[1500px] mx-auto px-6 md:px-10 h-9 flex items-center justify-between">
      <div className="flex items-center gap-6">
        <span className="flex items-center gap-1.5"><Truck size={13} /> Nationwide Delivery</span>
        <span className="flex items-center gap-1.5"><BadgePercent size={13} /> Wholesale Pricing</span>
        <span className="flex items-center gap-1.5"><ShieldCheck size={13} /> Trusted by NZ Businesses</span>
      </div>
      <div className="flex items-center gap-5">
        <a href="tel:+64221598639" className="flex items-center gap-1.5 hover:text-white transition-colors">
          <Phone size={13} /> Need help? Call 022 159 8639
        </a>
        <Link to="/trade-account" className="font-semibold text-vr-hygiene hover:text-white transition-colors">Open a Trade Account</Link>
      </div>
    </div>
  </div>
);
